
export default function BoardsList(props) {

  return (
    <h1> Not Found</h1>
  )
}